import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "../../screens/about";
import Career from "../../screens/career";
import Contact from "../../screens/contact";
import DataProtection from "../../screens/data-protection";
import Home from "../../screens/home";
import LegalNotice from "../../screens/legal-notice";
import Products from "../../screens/products";
import Projects from "../../screens/projects";
import Services from "../../screens/services";
import Footer from "../footer";
import HeaderMenu from "../header-menu";
import RouteSeo from "../route-seo";
import ScrollToTop from "../scroll-to-top";

const App = () => {
    return (
        <>
            <Router>
                <ScrollToTop/>
                <RouteSeo/>
                <HeaderMenu/>
                {/*<HeaderMenu/>*/}
                <div style={{
                    minHeight: "calc(100vh - 262px - 120px)", /* minus footer height */
                    paddingTop: "120px" /* header height */
                }}>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/projects" element={<Projects/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/products" element={<Products/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/services" element={<Services/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/career" element={<Career/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/about" element={<About/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/contact" element={<Contact/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/legal-notice" element={<LegalNotice/>}/>
                    </Routes>
                    <Routes>
                        <Route path="/data-protection" element={<DataProtection/>}/>
                    </Routes>
                </div>
                <Footer/>
            </Router>
        </>
    );
};

export default App;
